/**
 * GB-canvas-turntable.js
 * @class gbTurntable
 * @see https://github.com/givebest/GB-canvas-turntable
 * @author givenlovs@msn.com
 * @(c) 2016
 * */
/* eslint-disable no-undef */
/* eslint-disable no-extra-boolean-cast */

(function () {
  let $;
  let ele;
  let container;
  let canvas;
  let num;
  let prizes;
  let btn;
  let deg = 0;
  let fnGetPrize;
  let fnGotBack;
  let test;
  let optsPrize;

  let cssPrefix;
  let eventPrefix;
  const vendors = {
    '': '',
    Webkit: 'webkit',
    Moz: '',
    O: 'o',
    ms: 'ms',
  };
  const testEle = document.createElement('p');
  let cssSupport = {};

  // 嗅探特性
  Object.keys(vendors).some((vendor) => {
    if (testEle.style[`${vendor + (vendor ? 'T' : 't')}ransitionProperty`] !== undefined) {
      cssPrefix = vendor ? `-${vendor.toLowerCase()}-` : '';
      eventPrefix = vendors[vendor];
      return true;
    }
  });

  /**
   * [兼容事件前缀]
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */
  function normalizeEvent(name) {
    return eventPrefix ? eventPrefix + name : name.toLowerCase();
  }

  /**
   * [兼容CSS前缀]
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */
  function normalizeCss(name) {
    name = name.toLowerCase();
    return cssPrefix ? cssPrefix + name : name;
  }

  cssSupport = {
    cssPrefix,
    transform: normalizeCss('Transform'),
    transitionEnd: normalizeEvent('TransitionEnd'),
  };

  const { transform } = cssSupport;
  const { transitionEnd } = cssSupport;

  // alert(transform);
  // alert(transitionEnd);

  function init(opts) {
    fnGetPrize = opts.getPrize;
    fnGotBack = opts.gotBack;
    returncolor = opts.getcolor;

    // opts.color(function (color) {
    opts.config((data) => {
      prizes = opts.prizes = data.prizes;
      num = data.prizes.length;
      const colorlist = [
        LightenDarkenColor(data.color, 25), LightenDarkenColor(data.color, -25), LightenDarkenColor(data.color, -45),
      ];
      returncolor(colorlist);
      draw(opts, data.color);
    });
    // });
    events();
  }  
  
  /**
   * @param  {String} id
   * @return {Object} HTML element
   */
  $ = function (id) {
    return document.getElementById(id);
  };

  /**
   * [绘制转盘]
   * @param  {String} id
   * @param  {Number} 奖品份数
   */
  function draw(opts, color) {
    opts = opts || {};
    if (!opts.id || num >>> 0 === 0) return;

    const { id } = opts;
    const rotateDeg = 360 / num / 2 + 90; // 扇形回转角度
    let ctx;
    const prizeItems = document.createElement('ul'); // 奖项容器
    const turnNum = 1 / num; // 文字旋转 turn 值
    const html = []; // 奖项

    ele = $(id);
    canvas = ele.querySelector('.gb-turntable-canvas');
    container = ele.querySelector('.gb-turntable-container');
    btn = ele.querySelector('.gb-turntable-btn');

    if (!canvas.getContext) {
      showMsg('抱歉！浏览器不支持。');
      return;
    }
    // 获取绘图上下文
    ctx = canvas.getContext('2d');

    for (let i = 0; i < num; i++) {
      // 保存当前状态
      ctx.save();
      // 开始一条新路径
      ctx.beginPath();
      // 位移到圆心，下面需要围绕圆心旋转
      ctx.translate(150, 150);
      // 从(0, 0)坐标开始定义一条新的子路径
      ctx.moveTo(0, 0);
      // 旋转弧度,需将角度转换为弧度,使用 degrees * Math.PI/180 公式进行计算。
      ctx.rotate((360 / num * i - rotateDeg) * Math.PI / 180);
      // 绘制圆弧
      ctx.arc(0, 0, 150, 0, 2 * Math.PI / num, false);

      // 颜色间隔
      if (i % 2 == 0) {
        ctx.fillStyle = color;
      } else {
        ctx.fillStyle = LightenDarkenColor(color, 25);
      }

      // 填充扇形
      ctx.fill();
      // 绘制边框
      ctx.lineWidth = 0.5;
      ctx.strokeStyle = LightenDarkenColor(color, -25);
      ctx.stroke();

      // 恢复前一个状态
      ctx.restore();

      // 先清空物品
      // if(document.getElementsByClassName('gb-turntalbe-list').length > 0)
      // {
      //   var node = document.getElementsByClassName('gb-turntalbe-list')[0];
      //   node.innerHTML=''
      // }

      // 奖项列表
      var prizeList = opts.prizes;
      html.push('<li class="gb-turntable-item"> <span style="');
      html.push(transform + ': rotate(' + i * turnNum + 'turn)">');
      !!prizeList[i].image ? html.push('<img src="' + prizeList[i].image + '" />') : html.push('<font color="'+color+'">'+prizeList[i].detail[0].categoryName)
      html.push('</span> </li>');
      if ((i + 1) === num) {
        prizeItems.className = 'gb-turntalbe-list';
        container.appendChild(prizeItems);
        prizeItems.innerHTML = html.join('');
      }
    }
  }

  /**
   * [提示]
   * @param  {String} msg [description]
   */
  function showMsg(msg) {
    alert(msg);
  }

  /**
   * [初始化转盘]
   * @return {[type]} [description]
   */
  /*  function runInit() {
      removeClass(container, 'gb-run');
      container.style[transform] = 'rotate(0deg)';
      container.style[transform] = '';
    } */

  /**
   * 旋转转盘
   * @param  {[type]} deg [description]
   * @return {[type]}     [description]
   */
  function runRotate(deg) {
    // runInit();

    // setTimeout(function() {
    // addClass(container, 'gb-run');
    container.style[transform] = `rotate(${deg}deg)`;
    // }, 10);
  }

  /**
   * 抽奖事件
   * @return {[type]} [description]
   */
  function events() {
    bind(btn, 'click', () => {
      /*      var prizeId,
                chances; */

      // addClass(btn, 'disabled');

      // fnGetPrize((data) => {
      //   optsPrize = {
      //     prizeId: data[0],
      //     chances: data[1],
      //   };
      //   // 计算旋转角度
      //   deg = deg || 0;
      //   deg = deg + (360 - deg % 360) + (360 * 10 - data[0] * (360 / num));
      //   runRotate(deg);
      // });

      // // 中奖提示
      // bind(container, transitionEnd, eGot);
    });
  }

  function playroulette(){
    addClass(btn, 'disabled');

      fnGetPrize((data) => {
        optsPrize = {
          prizeId: data[0],
          chances: data[1],
        };
        // 计算旋转角度
        deg = deg || 0;
        deg = deg + (360 - deg % 360) + (360 * 10 - data[0] * (360 / num));
        runRotate(deg);
      });

      // 中奖提示
      bind(container, transitionEnd, eGot);
  }

  function eGot() {
    if (optsPrize.chances) removeClass(btn, 'disabled');
    fnGotBack(prizes[optsPrize.prizeId].detail[0].categoryName);
  }

  function LightenDarkenColor(col, amt) {
    let usePound = false;

    if (col[0] == '#') {
      col = col.slice(1);
      usePound = true;
    }

    const num = parseInt(col, 16);

    let r = (num >> 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    let b = ((num >> 8) & 0x00FF) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    let g = (num & 0x0000FF) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    const string = `000000${(g | (b << 8) | (r << 16)).toString(16)}`;
    return (usePound ? '#' : '') + string.substr(string.length - 6);
  }

  /**
   * Bind events to elements
   * @param {Object}    ele    HTML Object
   * @param {Event}     event  Event to detach
   * @param {Function}  fn     Callback function
   */
  function bind(ele, event, fn) {
    if (typeof addEventListener === 'function') {
      ele.addEventListener(event, fn, false);
    } else if (ele.attachEvent) {
      ele.attachEvent(`on${event}`, fn);
    }
  }

  /**
   * Unbind events to elements
   * @param {Object}    ele    HTML Object
   * @param {Event}     event  Event to detach
   * @param {Function}  fn     Callback function
   */
  /*  function unbind(ele, event, fn) {
        if (typeof removeEventListener === 'function') {
            ele.removeEventListener(event, fn, false);
        } else if (ele.detachEvent) {
            ele.detach('on' + event, fn);
        }
    } */

  /**
   * hasClass
   * @param {Object} ele   HTML Object
   * @param {String} cls   className
   * @return {Boolean}
   */
  function hasClass(ele, cls) {
    if (!ele || !cls) return false;
    if (ele.classList) {
      return ele.classList.contains(cls);
    }
    return ele.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`));
  }

  // addClass
  function addClass(ele, cls) {
    if (ele.classList) {
      ele.classList.add(cls);
    } else if (!hasClass(ele, cls)) ele.className += `${cls}`;
  }

  // removeClass
  function removeClass(ele, cls) {
    if (ele.classList) {
      ele.classList.remove(cls);
    } else {
      ele.className = ele.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
    }
  }

  const gbTurntable = {
    init (opts) {
      return init(opts);
    },
    run(){
      return playroulette();
    }
  };

  // (@see https://github.com/madrobby/zepto/blob/master/src/zepto.js)
  window.gbTurntable === undefined && (window.gbTurntable = gbTurntable);

  // AMD (@see https://github.com/jashkenas/underscore/blob/master/underscore.js)
  if (typeof define === 'function' && define.amd) {
    define('GB-canvas-turntable', [], () => gbTurntable);
  }
}());
